import { httpClient } from '@/infra/protocols/http';
import { IScriptDTO } from '@/modules/scripts/dtos/script.dto';
import { IScript } from '@/modules/scripts/entities/script.entity';
import { ScriptMapper } from '@/modules/scripts/mappers/script.mapper';

export namespace GetScriptsService {
  export interface Params {
    projectId: string;
    podcastId: string;
    episodeId: string;
  }
  export type Response = IScript[];
}

export async function getScripts(
  params: GetScriptsService.Params,
): Promise<GetScriptsService.Response> {
  const response = await httpClient.get<IScriptDTO[]>(
    `/v1/projetos/${params.projectId}/podcasts/${params.podcastId}/episodios/${params.episodeId}/roteiro`,
  );

  return response.map(ScriptMapper.toPresentation);
}
